import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';

export const ambassador = {
  name: '',
  position: 'right',
  description: '',
  image: '',
  socialLinks: {
    instagram: 'javascript:void(0)',
    youtube: 'javascript:void(0)',
    twitter: 'javascript:void(0)',
    tiktok: 'javascript:void(0)',
  },
};

export const EpochInfo = {
  title: 'FACEBOOK ART',
  period: '2004 - present',
  description: <>
    <p>
      Facebook Art is a vibrant blogging trend that sparked an explosive public response and propelled the evolution of social media blogging as we know it today.
    </p>
    <p>
      Emerging in the second half of the 2000s in the United States, Facebook Art developed alongside MySpacism. This movement is defined by the widespread creation of personal pages, which initially served as platforms for sharing thoughts but soon transformed into influential hubs with massive audiences. Creators within Facebook Art employ various techniques, including color correction, framing, editing, and visual effects. Its hallmark features include engaging challenges and eye-catching viral headlines.
    </p>
    <p>
      Today, Facebook blogging continues to thrive as a dynamic art movement, drawing in countless talented creators and viewers from around the globe.
    </p>
  </>,
};

export const events = [
  {
    year: '2004',
    title: 'Harvard Life',
    content: (
      <>
        <p>
          Facebook popped up right around the same time people started using the word "blog," so it's tough to say who the first blogger on Facebook really was. Mark Zuckerberg shared his experiences about campus life on his page, but whether that counts as a full-on blog is a bit of a gray area. Back then, photos made up most of the content on Facebook, which was pretty much the only way for students to keep up with each other's lives, as there weren't many other resources available.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|PHUUV*ED?0V9RV#kQkAxqyU,nEAE7xCt5t1WCniOmsAS6oet1xoslnjRoraJBwdjExVkCaObsoyWVw]SKk8xYfPoLXRobn.NeNHnlbvslW.s:NIf{n$nlf$s*j=j]a$WUSKWsV|R-j=bHo2fPWCoIj?oejrj?oLR+jZbH',
    picName: 'pic_01',
  },
  {
    year: '2007',
    title: 'Page After Page',
    content: (
      <>
        <p>
          Once Facebook broke out of university campuses, it took off like a rocket, jumping from 20 million users in April 2007 to 50 million by October. To get businesses on board, Facebook rolled out business page features, and by the end of the year, around 100,000 businesses had signed up.
        </p>
        <p>
          One of the standout moments from this time was the launch of the Humans of New York page by photographer Brandon Stanton. This awesome blog shares photos and stories of everyday New Yorkers and has attracted over 18 million subscribers.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|JE.*1%NR~t+xDMxe?t6WF_4-:W;ofWBaeozj@ae9Zt3s=r?RktQoyWCoc01NGs:RjkBozoLWBbHIARlWTS1x]WBV@s;WpIVM{WAjut7j?M{oLt7RjRPozoMWBj?kCfiazs;V@X8ofRjjFt7bFWBxafjf*ofaea{ofWBaf',
    picName: 'pic_02',
  },
  {
    year: '2014',
    title: 'The Advent of Algorithms',
    content: (
      <>
        <p>
          The rise of algorithm-driven feeds forced bloggers and brands to rethink their content strategies. Viral trends began spreading like wildfire, and one of the most memorable was the Ice Bucket Challenge. Celebrities across the globe, including Mark Zuckerberg, Bill Gates, and Chris Pratt, all joined in, pouring icy water over their heads and challenging others to do the same.
        </p>
        <p>
          During its peak from June to September, over 17 million Ice Bucket Challenge videos were shared on Facebook, amassing more than 10 billion views and reaching 440 million people. Around 28 million individuals took part in the discussions through posts, comments, and likes, with an incredible 2.4 million unique videos uploaded.
        </p>
        <p>
          The Ice Bucket Challenge set off a wave of flash mob trends on social media, but none have come close to replicating its viral success.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|GFQaptmT{M|]#w[RPWrs*YkVr9^XTIAozW@X9My6BtRV@slpIM{.7snozrcV@DPjZtmbvIAs+o#HrNe$KjExtWrMdoIjF%gR*xZozW=aextj[jFtmoeIpWBM|ofkWj]bcMxt6S5f+s:WBWqWBkCaJe.t7oLofbIWBWWn%',
    picName: 'pic_03',
  },
  {
    year: '2015',
    title: 'The Power of Celebrities',
    content: (
      <>
        <p>
          When Facebook introduced its Live feature in 2015, they took a bold step by bringing in celebrities to help promote it. Forbes reports that Facebook invested around $50 million to get high-profile stars to test out the platform. They even shelled out another $2.5 million to encourage media giants like BuzzFeed and the New York Times to use Facebook Live.
        </p>
        <p>
          The strategy paid off. By 2021, a Go-Globe article confirmed that Facebook Live had become the go-to platform for live content consumption.
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|MC=0ZENaLxDs9R*NHjbof}qRkNHt6kCbINdWCoLX7w^NeS1X8WCWVWXn%s.S4bbR*R*S4smofWC$LNIa#oyR,s.ofsmR+-9NdWXodWCsSoLj[ax-7S5WEWVjYWVs.Wqj@slR+R+kBofofo0jZfis.W;WXfiaysAWBjZoe',
    picName: 'pic_04',
  },
  {
    year: '2018',
    title: 'Maherco Gaming',
    content: (
      <>
        <p>
          As one of the fastest-growing sectors, gaming caught Facebook’s attention, leading to the launch of Facebook Gaming in 2018. This move opened the door for creators to thrive on the platform. Maherco Gaming emerged as a leading figure, quickly gaining 3.55 million followers. His futuristic studio became a popular destination for fans eager to watch him stream PUBG Mobile, showcasing the immense potential for creators to connect with large audiences.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|89GBjxwM}V?WUE2Efov9[}@JVNK-As.NHR*s,NG56ELOY=yt7of$ismxZIo$$S5ofS2S4s9Rks:bw$+xDS1WBNaNHNGNab^t7$$I:WBoKW=s.WBI:WBxFIqah-Ut6s:xG9ajExZX9j]$%ayNIxZEOxYs+kCNJf5o0NdxY',
    picName: 'pic_05',
  },
  {
    year: '2021',
    title: 'Flight from Twitch',
    content: (
      <>
        <p>
          After saying goodbye to Twitch, popular streamer Disguised Toast made a splash by signing an exclusive partnership with Facebook Gaming, bringing along his impressive audience of 1.5 million subscribers. He paved the way for others to follow, including stars like Corinna Kopf (11 million subscribers) and Kingslayer (472,000 subscribers), who quickly rose to prominence as leading streamers on the Facebook Gaming platform.
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|BC|hG5hWZ||FdnfogNaWY62OZxH$NoMsD,Ds:,q#j,]XAS2R$xHS2NZs9S6J6w|n,slw]J8s+S15*xHE_EzoLJVackDsq-DWVJ5S$w{J6OXNbOEadJ.soS1F0S1WZkBoKxGn$JUW-sANtxHNGJUNun%wcxHsAn+S1j@xF',
    picName: 'pic_06',
  },
  {
    year: '2021',
    title: 'Going Beyond Reality',
    content: (
      <>
        <p>
          Facebook, now rebranded as Meta, is all about creating the metaverse, where people can dive into virtual worlds and hang out together.
        </p>
        <p>
          Ariana Grande’s Rift Tour in Fortnite in August 2021 was a game-changer, pulling in a whopping 78 million fans with its epic visuals and fun gameplay. Travis Scott’s “Astronomical” concert in 2020 also made waves, attracting 45.8 million viewers with its incredible effects.
        </p>
        <p>
          These shows really highlight how the metaverse is becoming a go-to spot for massive live performances!
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|GH0##560$}uxwRirpEyadOIxGo#r;jYJTsoS4jb53tSr;J5NFWCo#s;s:-rI;i^f+Sir?s:soso0|w[=yi{sAXTr=n%fl=GNwR*t7jGsnSLW;ax9^SK$*R*juoLS2axWVSgs9ayafs;j?jFWWa}sCShoJS4smoJWXoLjZ',
    picName: 'pic_07',
  },
];